import React from "react";

/* ── Markdown Renderer ── */
export function MarkdownRenderer({ content }: { content: string }) {
  const lines = content.split("\n");
  return (
    <div className="prose prose-sm dark:prose-invert max-w-none text-foreground">
      {lines.map((line, i) => {
        if (/^### /.test(line))
          return (
            <h3
              key={i}
              className="text-base font-bold mt-4 mb-1 text-foreground"
            >
              {line.replace(/^### /, "")}
            </h3>
          );
        if (/^## /.test(line))
          return (
            <h2
              key={i}
              className="text-lg font-bold mt-5 mb-2 text-foreground border-b border-border pb-1"
            >
              {line.replace(/^## /, "")}
            </h2>
          );
        if (/^# /.test(line))
          return (
            <h1
              key={i}
              className="text-xl font-bold mt-6 mb-3 text-foreground border-b border-border pb-2"
            >
              {line.replace(/^# /, "")}
            </h1>
          );
        if (/^---+$/.test(line.trim()))
          return <hr key={i} className="border-border my-4" />;
        if (/^> /.test(line))
          return (
            <blockquote
              key={i}
              className="border-l-4 border-indigo-400 dark:border-indigo-500 pl-4 text-muted-foreground italic my-2"
            >
              {line.replace(/^> /, "")}
            </blockquote>
          );
        if (/^(\s*[-*+] )/.test(line)) {
          const indent = line.match(/^(\s*)/)?.[1].length ?? 0;
          return (
            <li
              key={i}
              className={`list-disc text-sm text-foreground ${indent > 0 ? "ml-6" : "ml-4"}`}
            >
              {inlineFormat(line.replace(/^\s*[-*+] /, ""))}
            </li>
          );
        }
        if (/^\s*\d+\. /.test(line))
          return (
            <li key={i} className="list-decimal ml-4 text-sm text-foreground">
              {inlineFormat(line.replace(/^\s*\d+\. /, ""))}
            </li>
          );
        if (/^```/.test(line)) return null;
        if (line.trim() === "") return <div key={i} className="h-2" />;
        return (
          <p key={i} className="text-sm leading-relaxed text-foreground my-0.5">
            {inlineFormat(line)}
          </p>
        );
      })}
    </div>
  );
}

function inlineFormat(text: string): React.ReactNode {
  // Bold, italic, inline code
  const parts = text.split(/(`[^`]+`|\*\*[^*]+\*\*|\*[^*]+\*)/g);
  return parts.map((part, i) => {
    if (/^`[^`]+`$/.test(part))
      return (
        <code
          key={i}
          className="px-1 py-0.5 rounded bg-slate-100 dark:bg-white/10 text-xs font-mono text-pink-600 dark:text-pink-400"
        >
          {part.slice(1, -1)}
        </code>
      );
    if (/^\*\*[^*]+\*\*$/.test(part))
      return (
        <strong key={i} className="font-bold">
          {part.slice(2, -2)}
        </strong>
      );
    if (/^\*[^*]+\*$/.test(part)) return <em key={i}>{part.slice(1, -1)}</em>;
    return part;
  });
}
